import React from 'react';
import AboutHeader from "./AboutHeader";
import Footer from './landing/Footer';
import Header from './landing/Header';
const Legal = () => {
   
    return (
        <div className="min-h-screen bg-white">
            <Header />
            {/* Solid Black Header */}
            <div className="bg-black py-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                        Legal
                    </h1>
                    <p className="text-sm text-white mt-8">
                        Effective Date: August 2025
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 mb-8">
                {/* Content Section */}
                <div className="max-w-4xl mx-auto space-y-6">
                    <div className="max-w-4xl mx-auto px-4 py-12">
                        <div className="text-sm text-gray-700 leading-normal space-y-4">
                            <div>
                                <h2 className="font-semibold text-base mb-2">1. Important Medical Information</h2>
                                <p className="mb-4">ADHDRapidCare provides telehealth mental health services through qualified doctors and registered and ADHD trained nurses. These services are designed to supplement—not replace—the relationship between you and your primary healthcare providers.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">2. Medical Disclaimer</h2>
                                <p className="mb-2"><strong>No Emergency Services:</strong></p>
                                <p className="mb-4">Our platform is not designed for medical emergencies. If you are experiencing a psychiatric emergency, suicidal thoughts, or any life-threatening condition, immediately contact emergency services (000 in Australia) or present to your nearest emergency department.</p>
                                
                                <p className="mb-2"><strong>Clinical Limitations:</strong></p>
                                <p className="mb-2">Our telehealth practitioners cannot:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Conduct physical examinations or laboratory tests</li>
                                    <li>Provide immediate emergency intervention</li>
                                    <li>Guarantee diagnostic accuracy without physical assessment</li>
                                    <li>Monitor all medication side effects in real time</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">3. Artificial Intelligence (AI) Use Disclaimer</h2>
                                <p className="mb-2"><strong>AI-Assisted Services:</strong></p>
                                <p className="mb-4">Our platform uses AI to support various stages of assessment, monitoring, and clinical decision support. All AI-generated data is reviewed by qualified professionals before treatment decisions are made.</p>
                                
                                <p className="mb-2"><strong>AI Limitations Include:</strong></p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>AI analysis is not a diagnosis</li>
                                    <li>AI may misinterpret inputs or miss relevant clinical detail</li>
                                    <li>Algorithms may be based on population data, not individual variation</li>
                                    <li>AI systems may contain bias and are continuously evolving</li>
                                </ul>
                                
                                <p className="mb-2"><strong>Liability Exclusion for AI Use:</strong></p>
                                <p className="mb-2">ADHDRapidCare, its practitioners, and its technology partners shall not be liable for:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>AI-generated inaccuracies</li>
                                    <li>Clinical outcomes influenced by AI analysis</li>
                                    <li>System bugs, technical malfunctions, or data errors</li>
                                    <li>Misinterpretation of AI-generated insights</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">4. ADHD Assessment and Care Limitations</h2>
                                <p className="mb-4">Diagnosis relies on patient-reported data and clinical judgment. Conditions mimicking ADHD or comorbid disorders may not be detected via telehealth alone. Further testing or referrals may be required.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">5. Medication Prescribing</h2>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Prescriptions are based solely on the information you provide</li>
                                    <li>Inaccurate disclosure may lead to inappropriate treatment</li>
                                    <li>Stimulant medications carry serious risks and require ongoing review</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">6. Professional Standards</h2>
                                <p className="mb-2">All clinicians are:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Registered with AHPRA</li>
                                    <li>Given comprehensive ADHD training</li>
                                    <li>Covered by professional indemnity insurance</li>
                                    <li>Bound by applicable ethical standards</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">7. Technology Platform & System Disclaimers</h2>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>No guarantee of uninterrupted access or perfect video/audio quality</li>
                                    <li>Compatibility may vary across devices and operating systems</li>
                                    <li>SMS delivery relies on external telecom providers and may fail</li>
                                    <li>AI monitoring and electronic systems may be affected by outages, upgrades, or user-side issues</li>
                                    <li>All electronic systems carry inherent data transmission risks despite encryption</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">8. Informed Consent & Acknowledgement</h2>
                                <p className="mb-2">By using our services, you consent to:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>All telehealth limitations and risks</li>
                                    <li>AI analysis of your clinical and monitoring data</li>
                                    <li>Secure electronic transmission and storage of health data</li>
                                    <li>Recording of sessions for training or quality assurance</li>
                                    <li>SMS-based monitoring and trend detection systems</li>
                                    <li>Possible requirement for physical follow-up if deemed necessary</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">9. Age and Capacity Requirements</h2>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Services for patients aged 18+ (minors must have guardian consent)</li>
                                    <li>Patients must be capable of understanding and engaging in their care</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">10. Billing & Subscription Terms</h2>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Full payment required before assessment services commence</li>
                                    <li>No refunds after services have started, except as required by law</li>
                                    <li>Subscription billed monthly ($79) or weekly ($20), auto-renewing until cancelled</li>
                                    <li>30-day written notice required for cancellation</li>
                                    <li>Missed appointment fees and rescheduling charges apply</li>
                                    <li>Medicare rebates are not available, but private insurance rebates may apply</li>
                                    <li>Health insurance rebates are not guaranteed. Coverage will depend on your                                                 individual policy, insurer rules, and eligibility requirements.
</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">11. Limitation of Liability</h2>
                                <p className="mb-2">To the fullest extent permitted by law, ADHDRapidCare is not liable for:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Diagnostic errors or treatment outcomes</li>
                                    <li>Medication side effects or failures</li>
                                    <li>AI-generated inaccuracies</li>
                                    <li>SMS monitoring system failures or delays</li>
                                    <li>Technology malfunctions, data loss, or downtime</li>
                                    <li>Third-party service provider failures (telecom, cloud, payment, pharmacy)</li>
                                    <li>Any indirect, consequential, or special damages (incl. lost income or emotional distress)</li>
                                </ul>
                                <p className="mb-4"><strong>Maximum Liability Cap:</strong><br />
                                Liability is limited to the amount paid for services in the 12 months prior to any claim.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">12. Intellectual Property</h2>
                                <p className="mb-4">All content, software, systems, and materials presented on the ADHDRapidCare platform are owned by ADHDRapidCare Pty Ltd. You are granted a limited license for personal use only. Reuse, copying, redistribution, or commercial exploitation is prohibited without written consent.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">13. Dispute Resolution</h2>
                                <p className="mb-2">If a dispute arises:</p>
                                <ol className="list-decimal pl-6 mb-4 space-y-1">
                                    <li>Contact our team to resolve the matter directly.</li>
                                    <li>If unresolved, submit a formal written complaint.</li>
                                    <li>If still unresolved, the dispute will be referred to mediation.</li>
                                    <li>As a final step, legal action may be taken in Australian courts.</li>
                                </ol>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">14. Governing Law</h2>
                                <p className="mb-4">These legal terms are governed by the laws of New South Wales, Australia, and applicable Commonwealth laws. Disputes will be handled under the jurisdiction of Australian courts.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">15. Force Majeure</h2>
                                <p className="mb-4">We are not responsible for service interruptions due to events beyond our control, including but not limited to: natural disasters, war, system failures, government restrictions, or pandemics.</p>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">16. Indemnification</h2>
                                <p className="mb-2">You agree to indemnify and hold harmless ADHDRapidCare and its practitioners for claims resulting from:</p>
                                <ul className="list-disc pl-6 mb-4 space-y-1">
                                    <li>Inaccurate personal/medical data provided</li>
                                    <li>Non-compliance with clinical instructions</li>
                                    <li>Misuse of prescribed medication</li>
                                    <li>Breach of terms or laws during your use of our services</li>
                                </ul>
                            </div>

                            <div>
                                <h2 className="font-semibold text-base mb-2">17. Modification of Terms</h2>
                                <p className="mb-4">We may modify these legal terms at any time. Continued use of the platform implies acceptance of the updated terms. The latest version will always be accessible on our website.</p>
                            </div>

                            <div className="mt-8 pt-4 border-t border-gray-300">
                                <p className="font-semibold mb-1">ADHDRapidCare Pty Ltd</p>
                                <p className="mb-1">ACN: 689674995 </p>
                                <p>Legal Contact: admin@adhdrapidcare.com.au</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default Legal;
